<template>
    <div>账号管理</div>
</template>

<script>
    export default {
        name: 'account-management'
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/home/money-management/account-management.vue